import styled from 'styled-components'

import theme from 'style/theme'

export default styled.div`
  box-shadow: 0 10px 20px 0 rgba(217, 167, 141, 0.15);
  border: solid 1px #ffdfc7;
  border-radius: 20px;
  overflow: hidden;
  background: ${theme.white};
  height: 100%;

  .image-block {
    /* max-height: 370px; */
    overflow: hidden;
    aspect-ratio: 1/1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .info-block {
    padding: 14px 20px;

    .title-block {
      height: 56px;
    }

    .date-block {
      text-align: right;
      .text-date {
        color: ${theme.mediumGray};
      }
    }

    .detail-block {
      margin-top: 5px;
      height: 44px;
    }

    .read-more-block {
      display: flex;
      align-items: center;
      .text-read-more {
        color: ${theme.primaryRed};
        margin-right: 4px;
      }
    }
  }
`
